import EmergencyContactModal from "./EmergencyContactModal";

export default EmergencyContactModal;
